import { create, parse, day, month, year } from "../fable_modules/fable-library.3.7.20/DateOnly.js";
import { class_type } from "../fable_modules/fable-library.3.7.20/Reflection.js";
import { printf, toText } from "../fable_modules/fable-library.3.7.20/String.js";
import { create as create_1, day as day_1, month as month_1, year as year_1, today } from "../fable_modules/fable-library.3.7.20/Date.js";

function $007CDateParts$007C(d) {
    return [year(d), month(d), day(d)];
}

export class DateFormat {
    constructor(toStr, parser) {
        this["toStr@6"] = toStr;
        this.parser = parser;
    }
}

export function DateFormat$reflection() {
    return class_type("Svea.Dry.Time.DateFormat", void 0, DateFormat);
}

export function DateFormat_$ctor_Z3C4C280B(toStr, parser) {
    return new DateFormat(toStr, parser);
}

export function DateFormat__parse_Z721C83C5(x, s) {
    return x.parser(s);
}

export function DateFormat__toStr_7FA2F3CE(x, d) {
    return x["toStr@6"](d);
}

export function DateFormat_get_yyyy$002DMM$002Ddd() {
    return DateFormat_$ctor_Z3C4C280B((_arg) => {
        const activePatternResult = $007CDateParts$007C(_arg);
        return toText(printf("%04d-%02d-%02d"))(activePatternResult[0])(activePatternResult[1])(activePatternResult[2]);
    }, (s) => {
        try {
            return parse(s);
        }
        catch (e) {
            return void 0;
        }
    });
}

export function DateFormatModule_toyyyyMMdd(d) {
    const arg_2 = day(d) | 0;
    const arg_1 = month(d) | 0;
    const arg = year(d) | 0;
    return toText(printf("%04d%02d%02d"))(arg)(arg_1)(arg_2);
}

export function DateModule_today() {
    const t = today();
    return create(year_1(t), month_1(t), day_1(t));
}

export function DateModule_parse(format, s) {
    return DateFormat__parse_Z721C83C5(format, s);
}

export function DateModule_toStr(format, d) {
    return DateFormat__toStr_7FA2F3CE(format, d);
}

export function DateModule_ofDateTime(dt) {
    return create(year_1(dt), month_1(dt), day_1(dt));
}

export function DateModule_toDateTime(d) {
    return create_1(year(d), month(d), day(d));
}

